export default __webpack_public_path__ + "media/themes-and-styles.6bd5b18463e62a22cc53fe939558588a.svg";